module.exports = __webpack_public_path__ + "img/journey1-0.9773c7ac.png";